import type { Task } from '../../types/task'
import { loadTasks, saveTasks } from '../../utils/storage'

export const readTasksFromLocalStorage = (): Task[] => loadTasks()

export const writeTasksToLocalStorage = (tasks: Task[]): void => {
  saveTasks(tasks)
}
